(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("MyPreferencesCtrl", ["myAccountResource", "messageService", "homePageService", "frameworkService", "profileRecord", "$scope", myPreferencesCtrl]);
    function myPreferencesCtrl(myAccountResource, messageService, homePageService, frameworkService, profileRecord, $scope) {
        var vm = this;
        vm.showErrors = false;
        vm.saving = false;
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.homePages = homePageService.getHomePages();
        vm.profileRecord = profileRecord;
        vm.save = function (isValid) {
            vm.saving = true;
            if (isValid) {
                var model = {
                    id: vm.profileRecord.id,
                    homePageTypeId: vm.profileRecord.homePageTypeId,
                    localizationId: vm.profileRecord.localizationId,
                    tenantShowDoNotSellPersonalInfo: vm.profileRecord.tenantShowDoNotSellPersonalInfo,
                    doNotSellPersonalInfo: vm.profileRecord.doNotSellPersonalInfo
                };
                myAccountResource.updateMyPreferences(model, function () {
                    //homePageService.changeHomePage(model.homePageTypeId);
                    //TODO - PBI - save homepage to authSetting
                    messageService.success("account.profile.updated");
                    $scope.$close(model);
                }, function (error) {
                    vm.saving = false;
                    messageService.error(error);
                });
            }
            else {
                vm.showErrors = true;
                vm.saving = false;
            }
        };
    }
}());
